import React, {Component} from 'react';
import './TermsAndConditions.less';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {Switch} from '@homeaway/react-form-components';
import {apiPost} from '../../util/api.client';
import ClientLogger from '../../util/clientLogger';


class TermsAndConditionsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: this.props.emailAddress,
            site: this.props.site,
            TandCSwitch: this.props.TandCSwitch,
            updatePage: this.props.updatePage
        };
        this.handleTCClicked = this.handleTCClicked.bind(this);
        this.handleToggleClicked = this.handleToggleClicked.bind(this);
    }

    checkStatus(response) {
        switch (response.status) {
            case 200:
                return response.json();
            default:
                ClientLogger.logError(`An error has occurred : ${response.status} - ${response.statusText}`);
                break;
        }
        return null;
    }

    handleTCClicked() {
        if (this.state.TandCSwitch) {
            const statusRequest = {
                'emailAddress': this.state.emailAddress,
                'site': this.state.site,
                'sourceUrl': window.location.href,
                'source': 'lightbox.signup.inquiry'
            };
            // update this so we don't have to worry about rolling back the edge rule in test and stage
            const url = '/newsletter-subscriptions/v1/subscriptions';
            apiPost(url, statusRequest).then(this.checkStatus);
        }
        this.state.updatePage('postTandC');
    }

    handleToggleClicked(event) {
        this.setState({[event.target.name]: event.target.checked});
    }

    render() {
        let buttonLabel = this.props.lingua.read('lex.button.accept.terms.conditions');
        let options = {'siteName': this.props.siteName};
        let text = this.props.lingua.read('lex.signup.termsandcondtions');
        return (
            <div className="TermsAndConditionsComponent text-center">
                <form className="TermsAndComponentForm">
                    <div className="terms-and-conditions" href=""><label dangerouslySetInnerHTML={{__html: text}}/></div>
                    <ButtonPrimary label={buttonLabel} onClick={this.handleTCClicked} className="btn-lg">
                        <LoadingOverlay loading={this.props.isWaiting}/>
                    </ButtonPrimary>
                    <div className="vacation-ideas-container">
                        <div className="vacation-ideas" href="">{this.props.lingua.read('lex.signup.vacation.ideas', options)}</div>
                        <div className="tc-toggle-switch">
                            <Switch
                                name="TandCSwitch"
                                id="toggle-switch"
                                className="toggle"
                                onChange={this.handleToggleClicked}
                                size="sm"
                            />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default TermsAndConditionsComponent;
